export enum UKCountryCodes {
  UK = 'UK',
  GB = 'GB',
}
